import { Directive, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

@Directive({
  selector: '[sharedScrollPosition]',
  standalone: false,
})
export class ScrollPositionDirective implements OnInit, OnDestroy {
  @Input() scrollContainerId = 'main-sidenav-content';
  @Output() scrollNearEnd = new EventEmitter<void>();
  @Output() scrollToTop = new EventEmitter<void>();

  private readonly scrollHandler = this.onScroll.bind(this);
  private scrollSourceElement: HTMLElement | null = null;

  ngOnInit(): void {
    this.scrollSourceElement = document.getElementById(this.scrollContainerId);
    if (this.scrollSourceElement == null) {
      console.error(`ScrollPositionDirective: ${this.scrollContainerId} element not found. Lazy loading will not work.`);
      return;
    }
    this.scrollSourceElement.addEventListener('scroll', this.scrollHandler, { passive: true });
  }

  ngOnDestroy(): void {
    if (this.scrollSourceElement) {
      this.scrollSourceElement.removeEventListener('scroll', this.scrollHandler);
    }
  }

  private onScroll(): void {
    const element = this.scrollSourceElement;
    if (!element) {
      return;
    }

    if (element.scrollTop === 0) {
      this.scrollToTop.emit();
    }

    const heightOfElement = element.scrollHeight;
    const innerHeight = element.clientHeight;
    const scrollToBottom = heightOfElement - innerHeight - element.scrollTop;

    // if we are near the end of the element emit event ( 1/6 works great)
    if (scrollToBottom < heightOfElement / 6) {
      this.scrollNearEnd.emit();
    }
  }
}
